(function () {
  const PRODUCTS_QUERY = `query GrabSearchProducts($query: String!, $first: Int!, $after: String, $sortKey: ProductSortKeys!, $reverse: Boolean!) {
  products(first: $first, after: $after, query: $query, sortKey: $sortKey, reverse: $reverse) {
    edges { cursor node { id handle title availableForSale featuredImage { url(transform:{maxWidth:800}) altText width height } priceRange { minVariantPrice { amount currencyCode } } compareAtPriceRange { minVariantPrice { amount currencyCode } } } }
    pageInfo { hasNextPage hasPreviousPage startCursor endCursor }
  }
}`;
  const PRODUCTS_COUNT_QUERY = `query GetTotalCount($query: String!, $filters: [ProductFilter!]) {
  search(query: $query, types: PRODUCT, first: 1, productFilters: $filters) {
    totalCount
  }
}`;

  function buildStorefrontQuery(sp) {
    const parts = [];
    if (sp.q) {
      parts.push(sp.q);
    }
    (sp.tags || []).forEach(function (tag) {
      if (tag) {
        parts.push(`tag:${tag}`);
      }
    });
    if (sp.availability === '1') {
      parts.push('available_for_sale:true');
    }
    if (parts.length === 0) {
      return 'status:active';
    }
    return parts.join(' AND ');
  }

  function buildStorefrontCountQuery(sp) {
    const q = (sp && sp.q) || '';
    return q || 'status:active';
  }

  function buildStorefrontFilters(sp) {
    const filters = [];
    (sp.tags || []).forEach(function (tag) {
      if (tag) {
        filters.push({ tag: tag });
      }
    });
    if (sp.availability === '1') {
      filters.push({ available: true });
    }
    return filters;
  }

  function formatMoney(amountStr, currencyCode) {
    const amount = parseFloat(amountStr, 10);
    if (isNaN(amount)) {
      return amountStr;
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD',
      }).format(amount);
    } catch (e) {
      return `${amountStr} ${currencyCode}`;
    }
  }

  function productUrl(handle) {
    //const base = (window.shopUrl || '').replace(/\/$/, '');
    const base = location.host
    return `//${base}/products/${handle}`;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderProductCard(node, options) {
    const opts = options || {};
    function pick(key, fallback) {
      return Object.prototype.hasOwnProperty.call(opts, key) ? opts[key] : fallback;
    }

    const cardClass = pick('cardClass', 'grab-search-gql-card');
    const linkClass = pick('linkClass', 'grab-search-gql-card__link');
    const mediaClass = pick('mediaClass', 'grab-search-gql-card__media');
    const textClass = pick('textClass', 'grab-search-gql-card__text');
    const titleClass = pick('titleClass', 'grab-search-gql-card__title');
    const priceRowClass = pick('priceRowClass', 'grab-search-gql-card__price-row');
    const pricePartClass = pick('pricePartClass', 'grab-search-gql-card__price-part');
    const compareClass = pick('compareClass', 'grab-search-gql-card__price-part--compare');
    const badgeClass = pick('badgeClass', 'grab-search-gql-card__badge');
    const soldOutLabel = pick('soldOutLabel', '');
    const itemClass = pick('itemClass', 'grid__item');

    const url = productUrl(node.handle);
    const img = node.featuredImage;
    const imgUrl = img && img.url ? img.url : '';
    const alt = (img && img.altText) || node.title || '';
    const price = node.priceRange && node.priceRange.minVariantPrice;
    const compare = node.compareAtPriceRange && node.compareAtPriceRange.minVariantPrice;
    let priceHtml = '';
    if (price) {
      const pAmt = parseFloat(price.amount, 10);
      const cAmt = compare ? parseFloat(compare.amount, 10) : NaN;
      const showCompare = !isNaN(cAmt) && cAmt > pAmt;
      if (showCompare) {
        priceHtml += `<span class="${compareClass} ${pricePartClass}">${escapeHtml(
          formatMoney(compare.amount, compare.currencyCode)
        )}</span>`;
      }
      priceHtml += `<span class="${pricePartClass}">${escapeHtml(
        formatMoney(price.amount, price.currencyCode)
      )}</span>`;
    }
    const badge =
      node.availableForSale === false
        ? `<span class="${badgeClass}">${escapeHtml(soldOutLabel)}</span>`
        : '';
    const imgTag = imgUrl
      ? `<img src="${escapeHtml(imgUrl)}" alt="${escapeHtml(alt)}" width="${
          img.width || 533
        }" height="${img.height || 533}" loading="lazy">`
      : '';

    return `<li class="${itemClass} ${cardClass}"><a class="${linkClass}" href="${escapeHtml(
      url
    )}"><div class="${mediaClass}">${badge}${imgTag}</div><div class="${textClass}"><p class="${titleClass}">${escapeHtml(
      node.title || ''
    )}</p><div class="${priceRowClass}">${priceHtml}</div></div></a></li>`;
  }

  async function fetchStorefront(cfg, query, variables) {
    const endpoint = `https://${cfg.shopDomain}/api/${cfg.apiVersion}/graphql.json`;
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': cfg.token,
      },
      body: JSON.stringify({ query: query, variables: variables }),
    });
    const json = await res.json();
    if (json.errors && json.errors.length) {
      throw new Error(
        json.errors
          .map(function (e) {
            return e.message;
          })
          .join('; ')
      );
    }
    return json.data;
  }

  window.grabSearchStorefrontShared = {
    PRODUCTS_QUERY: PRODUCTS_QUERY,
    PRODUCTS_COUNT_QUERY: PRODUCTS_COUNT_QUERY,
    buildStorefrontQuery: buildStorefrontQuery,
    buildStorefrontCountQuery: buildStorefrontCountQuery,
    buildStorefrontFilters: buildStorefrontFilters,
    renderProductCard: renderProductCard,
    fetchStorefront: fetchStorefront,
    escapeHtml: escapeHtml,
  };
})();
